var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"container mb-0"},[_c('p',{staticClass:"mb-0"},[_vm._v("© "+_vm._s(_vm.currentYear)+" Argusoft | All Rights Reserved")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }